<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" lg="4" class="text-center">
            <v-progress-circular indeterminate color="primary" size="48" v-if="!error"></v-progress-circular>
            <p class="mt-4" v-if="!error">{{ $t('views.Login.LoginTitle') }}...</p>
            <v-alert type="error" v-if="error">{{ error }}</v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
  export default {
    name: "OidcCallback",
    data: () => ({
      error: null,
    }),
    mounted() {
      const code = this.$route.query.code
      const returnedState = this.$route.query.state
      if (!code) {
        this.error = this.$t("views.Login.Unauthorized")
        return
      }
      const redirectUri = localStorage.getItem("oidc_redirect_uri")
      const provider = localStorage.getItem("oidc_provider")
      const state = localStorage.getItem("oidc_state")
      const nonce = localStorage.getItem("oidc_nonce")
      if (!redirectUri || !provider) {
        this.error = this.$t("views.Login.Unauthorized")
        return
      }
      if (state && returnedState && state !== returnedState) {
        this.error = this.$t("views.Login.Unauthorized")
        return
      }
      let formData = new FormData()
      formData.set("provider", provider)
      formData.set("code", code)
      formData.set("redirect_uri", redirectUri)
      if (state) formData.set("state", state)
      if (nonce) formData.set("nonce", nonce)
      this.$store.dispatch("oauthlogin", formData)
        .then(() => {
          localStorage.removeItem("oidc_redirect_uri")
          localStorage.removeItem("oidc_provider")
          localStorage.removeItem("oidc_state")
          localStorage.removeItem("oidc_nonce")
          this.$router.push("/")
        })
        .catch(() => {
          this.error = this.$t("views.Login.Unauthorized")
        })
    },
  }
</script>
